import { SocketMessageInterface } from "../../../interfaces/Monitoring.interface";

export default function hasStateChanged(
  prev: SocketMessageInterface | undefined,
  next: SocketMessageInterface,
): boolean {
  if (!prev) return true;
  if (
    prev.direction !== next.direction ||
    prev.connected !== next.connected ||
    prev.faults !== next.faults ||
    prev.doorStatus?.frontOpen !== next.doorStatus?.frontOpen ||
    prev.doorStatus?.rearOpen !== next.doorStatus?.rearOpen ||
    prev.carCalls !== next.carCalls ||
    prev.hallCalls !== next.hallCalls ||
    prev.msg !== next.msg ||
    prev.usage !== next.usage ||
    prev.bitmask !== next.bitmask ||
    prev.positionMap !== next.positionMap ||
    prev.serviceMap !== next.serviceMap ||
    // A verdict frame repeats the message that was COMMANDED, so every other
    // comparison above finds it identical to what the state already holds. Left
    // out, the one frame that reports whether a command worked would be
    // suppressed here as "nothing changed" — which is precisely backwards.
    prev.ack !== next.ack ||
    // A Withheld verdict changes nothing BUT the ack and this list, and a mark
    // expiring or clearing changes only this list — the floor cell must still
    // hear about both.
    prev.withheldCalls !== next.withheldCalls
  ) {
    return true;
  }
  // Compare activeFaults
  const prevFaults = prev.activeFaults || [];
  const nextFaults = next.activeFaults || [];
  if (prevFaults.length !== nextFaults.length) return true;
  for (let i = 0; i < prevFaults.length; i += 1) {
    if (
      prevFaults[i].faultType !== nextFaults[i].faultType ||
      prevFaults[i].fault?.fault?.message !== nextFaults[i].fault?.fault?.message
    ) {
      return true;
    }
  }
  return false;
}
